import { render, staticRenderFns } from "./ParentDetail.vue?vue&type=template&id=d3505af0&scoped=true"
import script from "./ParentDetail.vue?vue&type=script&lang=js"
export * from "./ParentDetail.vue?vue&type=script&lang=js"
import style0 from "./ParentDetail.vue?vue&type=style&index=0&id=d3505af0&prod&scoped=true&lang=less"
import style1 from "./ParentDetail.vue?vue&type=style&index=1&id=d3505af0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3505af0",
  null
  
)

export default component.exports